

function uniformButtonWidths() {
   
    const buttons = document.querySelectorAll('.textSecondaryTitleHighlightContentBlock .button');
    if (buttons.length === 0) return;

    let maxWidth = 0;
    buttons.forEach(button => {
        const buttonWidth = button.offsetWidth; 
        if (buttonWidth > maxWidth) {
            maxWidth = buttonWidth; 
        }
    });

    // Applica la larghezza massima a tutti i bottoni
    buttons.forEach(button => {
        button.style.width = `${maxWidth}px`;
    });
}


window.onload = uniformButtonWidths;